function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fff"
}, React.createElement("circle", {
  cx: 30,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 34,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 34,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 34,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 35.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 35.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 35.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 37.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 41.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 42.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 42.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 42.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 45.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 47.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 47.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 48.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 50.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 51.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 55.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 56.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 57.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 58.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 59.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 60.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 62.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 64.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 67,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 67.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 70.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 71.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 72.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 74.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 76.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 80.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 80.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 81.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 85.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 85.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 85.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 88.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 92.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 93.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 99.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 102.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 104.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 111.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 114.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 114.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 115.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 126.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 131.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 143.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 167.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 169,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 194.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 195.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 197,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 202.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 233.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 238,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 242.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 243.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 248.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 256.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 280.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 297.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 314.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 316.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 319.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 321.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 326.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 328,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 366.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 381.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 393.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 395.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 403.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 405.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 407.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 409,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 419.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 422.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 426.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 434,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 434.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 437.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 452.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 459.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 460.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 463.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 464.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 467.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 467.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 469.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 484.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 487,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 499.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 502.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 516.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 521.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 536.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 537.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 540.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 550.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 551.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 552,
  cy: 62,
  r: 30,
  opacity: 0.03
}));

var SvgCountryFigures06 = function SvgCountryFigures06(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 582 124",
    style: {
      backgroundColor: "#0d5b61"
    }
  }, props), _ref);
};

export default SvgCountryFigures06;